import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/activity",
)({
	component: AdminTicketTypeActivityTab,
});

function AdminTicketTypeActivityTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="p-4">
			<TicketTypeActivitySection ticketType={ticketType} />
		</div>
	);
}
